module.exports = __webpack_public_path__ + "static/media/office6.bcbd1c91.jpg";